import React from "react";
import { Stepper } from "material-ui/Stepper";

export default class CustomStepper extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            style = {},
            activeStep = {},
            linear = true,
            connector,
            orientation = "horizontal"
        } = this.props;
        return (
            <Stepper
                {...this.props}
                style={Object.assign({}, style)}
                activeStep={activeStep}
                linear={linear}
                connector={connector}
                orientation={orientation}
            />
        );
    }
}
